import { q } from 'groqd'

export const productNavigationQuery = q('*')
  .filter('_type == "productNavigation" && market==$market')
  .grab({
    productCategories: q('productCategories')
      .filter()
      .grab({
        _key: q.string(),
        title: ['title[$lang]', q.string()],
        products: q('products')
          .filter()
          .deref()
          .grab({
            _key: ['_id', q.string()],
            _ref: ['_id', q.string()],
            _type: q.union([q.literal('abstractProduct'), q.literal('mgaLightProduct')]),
          }),
      }),
  })
  .slice(0)
